import React, { useState } from 'react'
import { BASE_BACKEND_URL } from '../auth'

import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import TimedToastAlert from '../components/alerts/TimedToastAlert'
import LoginPasswordField from './shared/LoginPasswordField'
import PasswordRulesPanel from './shared/PasswordRulesPanel'
import LoginShell from './shared/LoginShell'
import { isPasswordValid } from './shared/passwordValidation'

export default function ConfirmNewPasswordPage() {
  const { token: pathToken } = useParams()
  const [searchParams] = useSearchParams()
  const [newPassword, setNewPassword] = useState('')
  const [confirmNewPassword, setConfirmNewPassword] = useState('')
  const [showNewPassword, setShowNewPassword] = useState(false)
  const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false)
  const [message, setMessage] = useState('')
  const [alertId, setAlertId] = useState(0)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const token = searchParams.get('token') || pathToken || ''
  const navigate = useNavigate()
  const canSubmitPassword = isPasswordValid(newPassword, confirmNewPassword)

  const showError = (text) => {
    setMessage(text)
    setAlertId(Date.now())
  }

  const sendResetRequest = (event) => {
    event.preventDefault()
    if (!isPasswordValid(newPassword, confirmNewPassword)) {
      showError('ERROR: La contraseña no cumple con las reglas requeridas.')
      return
    }

    setMessage('')
    setIsSubmitting(true)

    fetch(`${BASE_BACKEND_URL}/users/password`, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        user: {
          password: newPassword,
          password_confirmation: confirmNewPassword,
          reset_password_token: token
        }
      })
    })
      .then((response) => {
        if (response.status === 200 || response.status === 204) {
          navigate('/?reset_done=true', { replace: true })
          return
        }
        if (response.status === 422) {
          showError('ERROR: Token invalido o expirado.')
          return
        }
        showError('ERROR: Hubo un error en la solicitud. Vuelva a intentarlo.')
      })
      .catch(() => {
        showError('ERROR: Hubo un error en la solicitud. Vuelva a intentarlo.')
      })
      .finally(() => setIsSubmitting(false))
  }

  return (
    <LoginShell
      eyebrow="Recuperación de acceso"
      title="Ingresar contraseña nueva"
      subtitle="Debe cumplir las reglas de seguridad."
    >
      <form className="login-main-form" onSubmit={sendResetRequest} noValidate>
        {message ? (
          <div className="login-form-alert" aria-live="polite">
            <TimedToastAlert
              id={alertId}
              variant="inline"
              severity="error"
              message={message}
              onClose={() => setMessage('')}
            />
          </div>
        ) : null}

        <LoginPasswordField
          id="confirm-new-password"
          label="Contraseña"
          name="newPassword"
          value={newPassword}
          onChange={(event) => setNewPassword(event.target.value.slice(0, 15))}
          showPassword={showNewPassword}
          onTogglePassword={() => setShowNewPassword((current) => !current)}
          autoFocus
        />
        <LoginPasswordField
          id="confirm-new-password-confirmation"
          label="Confirmar Contraseña"
          name="confirmNewPassword"
          value={confirmNewPassword}
          onChange={(event) => setConfirmNewPassword(event.target.value.slice(0, 15))}
          showPassword={showConfirmNewPassword}
          onTogglePassword={() => setShowConfirmNewPassword((current) => !current)}
        />
        <PasswordRulesPanel
          password={newPassword}
          passwordConfirmation={confirmNewPassword}
        />

        <button
          className={`login-submit-btn${isSubmitting ? ' is-loading' : ''}`}
          type="submit"
          disabled={isSubmitting || !canSubmitPassword}
        >
          <span className="login-submit-label">Cambiar contraseña</span>
          <span className="login-submit-spinner" aria-hidden="true" />
        </button>
      </form>

      <p className="login-form-footer">
        <Link className="login-forgot-link" to="/">
          Iniciar Sesión
        </Link>
      </p>
    </LoginShell>
  )
}
